export * from './clinical-trials.service';
export * from './defs';